
import React from 'react';
import CommentItem from '@/components/community/CommentItem';
import { CommentType } from '@/components/reader-home/types';

interface CommentsListProps {
  comments: CommentType[];
  onReply: (commentId: number, content: string) => void;
  hasFilters: boolean;
}

const CommentsList: React.FC<CommentsListProps> = ({ 
  comments, 
  onReply,
  hasFilters
}) => {
  if (comments.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        {hasFilters ? (
          <p>No comments found for the selected topics. Try different topics or clear filters.</p>
        ) : (
          <p>No comments yet. Be the first to start the discussion!</p>
        )}
      </div>
    );
  }

  return (
    <div>
      {comments.map(comment => (
        <CommentItem 
          key={comment.id} 
          comment={comment} 
          onReply={onReply}
        />
      ))}
    </div>
  );
};

export default CommentsList;
